import { WfnNumberBox } from '@adp-wfn/mdf-wc-react';
import React, { useCallback } from 'react';
import { Field } from './types';

/**
 * Number input field component with min/max validation
 * @param props - Field component props
 * @param props.id - Unique field identifier
 * @param props.data - Field configuration with value, min, and max
 * @param props.onChange - Callback function for value changes
 * @returns JSX element for number input field
 */
export function Number({ id, data, onChange }: Field) {
  const handleChange = useCallback(
    (event: any) => onChange(event?.detail ?? null),
    [onChange]
  );

  return (
    <WfnNumberBox
      id={id}
      label={data.label}
      max={data.max}
      min={data.min}
      required={data.required}
      tooltipText={data.tooltipText}
      value={data.value}
      onSdfChange={handleChange}
    />
  );
}
